import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { CSVLink } from 'react-csv';
import bulkExport from '../../img/bulk_template/bulk_vehicle.csv';
import '../../entity-forms.css';

export default function Vehicle() {
  const API_URL = process.env.REACT_APP_API_URL;

  const [data, setdata]             = useState([]);
  const [isload, setisload]         = useState(true);
  const [teams, setteams]           = useState([]);
  const [vehicleModels, setVehicleModels] = useState([]);
  const [search, setSearch]         = useState('');

  const initForm = { user: sessionStorage.getItem('userid'), isActive: true };
  const [form, setForm]             = useState(initForm);
  const [isEdit, setIsEdit]         = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [msg, setMsg]               = useState('');
  const [errMsg, setErrMsg]         = useState('');

  useEffect(() => { loadList(); loadTeams(); loadModels(); }, []);

  const loadList = async () => {
    setisload(true);
    try {
      const res = await axios.get(`${API_URL}shypvdriverapp/vehicle/getVehicles`);
      if (res.data.success) setdata(res.data.data);
    } catch {}
    setisload(false);
  };

  const loadTeams = async () => {
    try {
      const res = await axios.get(`${API_URL}shypvdriverapp/team/getTeams`);
      if (res.data.data) setteams(res.data.data);
    } catch {}
  };

  const loadModels = async () => {
    try {
      const res = await axios.get(`${API_URL}shypvdriverapp/vehicleModel/getModels`);
      if (res.data?.data) setVehicleModels(res.data.data);
    } catch {}
  };

  const openAdd  = () => { setForm(initForm); setIsEdit(false); setMsg(''); setErrMsg(''); setDrawerOpen(true); };
  const openEdit = (row) => { setForm({ ...row }); setIsEdit(true); setMsg(''); setErrMsg(''); setDrawerOpen(true); };
  const closeDrawer = () => { setDrawerOpen(false); setForm(initForm); };

  const handleModelChange = (e) => {
    const id = e.target.value;
    const model = vehicleModels.find(m => String(m.vehicle_model_code) === String(id));
    setForm(prev => ({
      ...prev,
      vehicle_model_id: id,
      fleet_type:    model?.fleet_type || '',
      fuel_type:     model?.fuel_type  || '',
      transported_id: 1,
    }));
  };

  const validate = () => {
    if (!form.vehicle_name || !form.vehicle_registration_number || !form.team || !form.vehicle_model_id) {
      setMsg('Please fill all required fields (*)');
      return false;
    }
    setMsg('');
    return true;
  };

  const handleSubmit = async () => {
    if (!validate()) return;
    try {
      const payload = {
        vehicle_name:                form.vehicle_name,
        vehicle_registration_number: form.vehicle_registration_number,
        team:          parseInt(form.team, 10),
        vehicle_model_id:            form.vehicle_model_id,
        transported_id: isNaN(parseInt(form.transported_id, 10)) ? 0 : parseInt(form.transported_id, 10),
        fleet_type:    form.fleet_type,
        fuel_type:     form.fuel_type,
        isActive:      form.isActive === true || form.isActive === 1 ? 1 : 2,
        mileage:       parseInt(form.mileage, 10) || 0,
      };
      if (isEdit) payload.vehicle_code = form.vehicle_code;
      const url = isEdit
        ? `${API_URL}shypvdriverapp/vehicle/updateVehicle`
        : `${API_URL}shypvdriverapp/vehicle/createVehicle`;
      const res = await axios.post(url, payload, { headers: { 'Content-Type': 'application/json' } });
      if (res.data.success) { closeDrawer(); loadList(); }
      else setMsg('Operation failed. Please try again.');
    } catch (e) { setErrMsg('Server error: ' + (e.response?.data?.message || e.message)); }
  };

  const handleDelete = async () => {
    if (!selectedIds.length) return;
    if (!window.confirm(`Delete ${selectedIds.length} vehicle(s)?`)) return;
    try {
      const res = await axios.delete(`${API_URL}shypvdriverapp/vehicle/deleteVehicle`, {
        headers: { 'Content-Type': 'application/json' },
        data: { vehicle_codes: selectedIds },
      });
      if (res.data.success) { setSelectedIds([]); loadList(); }
      else setErrMsg(res.data.errors?.[0]?.errorDetails || 'Delete failed');
    } catch { setErrMsg('Error deleting vehicle'); }
  };

  const toggleSelect = (code, row) => {
    setSelectedIds(prev => {
      if (prev.includes(code)) { const next = prev.filter(id => id !== code); if (next.length === 0) setForm(initForm); return next; }
      setForm(row);
      return [...prev, code];
    });
  };

  const filtered = data.filter(r =>
    !search ||
    r.vehicle_name?.toLowerCase().includes(search.toLowerCase()) ||
    r.vehicle_registration_number?.toLowerCase().includes(search.toLowerCase()) ||
    String(r.vehicle_code).includes(search)
  );

  const role = sessionStorage.getItem('role');
  const canDelete = role === 'super_admin' || role === 'admin';

  return (
    <div style={{ fontFamily: "'Poppins', sans-serif" }}>
      <div className="em-action-bar">
        <div className="em-search-wrap">
          <i className="fa fa-search" />
          <input className="em-search" placeholder="Search vehicles…" value={search} onChange={e => setSearch(e.target.value)} />
        </div>
        <button className="em-btn em-btn-primary" onClick={openAdd}><i className="fa fa-plus" /> Add Vehicle</button>
        {selectedIds.length === 1 && (
          <button className="em-btn em-btn-warning" onClick={() => openEdit(form)}><i className="fa fa-pencil" /> Edit</button>
        )}
        {selectedIds.length > 0 && canDelete && (
          <button className="em-btn em-btn-danger" onClick={handleDelete}><i className="fa fa-trash" /> Delete ({selectedIds.length})</button>
        )}
        <CSVLink data={filtered} filename="vehicles.csv" className="em-btn em-btn-csv"><i className="fa fa-download" /> Export</CSVLink>
        <a href={bulkExport} download className="em-btn em-btn-ghost"><i className="fa fa-file-text-o" /> Template</a>
        {errMsg && <span className="em-msg-error">{errMsg}</span>}
      </div>

      <div style={{ overflowX: 'auto' }}>
        <table className="em-table">
          <thead>
            <tr>
              <th className="em-col-h" style={{ width: 36 }}>
                <input type="checkbox"
                  onChange={e => setSelectedIds(e.target.checked ? filtered.map(r => r.vehicle_code) : [])}
                  checked={selectedIds.length > 0 && selectedIds.length === filtered.length} />
              </th>
              {['Code','Name','Reg. Number','Team','Model','Fleet','Fuel','Active','Mileage','Actions'].map(h =>
                <th key={h} className="em-col-h">{h}</th>
              )}
            </tr>
          </thead>
          <tbody>
            {isload ? (
              <tr><td colSpan={11} style={{ textAlign:'center', padding:40, color:'#94a3b8' }}>
                <i className="fa fa-spinner fa-spin" style={{ fontSize:22, display:'block', marginBottom:8 }} />Loading vehicles…
              </td></tr>
            ) : filtered.length === 0 ? (
              <tr><td colSpan={11} style={{ textAlign:'center', padding:40, color:'#94a3b8' }}>
                <i className="fa fa-truck" style={{ fontSize:32, opacity:0.2, display:'block', marginBottom:8 }} />No vehicles found
              </td></tr>
            ) : filtered.map((row, i) => {
              const sel = selectedIds.includes(row.vehicle_code);
              return (
                <tr key={row.vehicle_code} className={`em-tr${sel?' selected':''}`}
                  style={{ animation:`emFadeUp 0.3s ${Math.min(i,20)*0.018}s ease-out both` }}>
                  <td className="em-td"><input type="checkbox" checked={sel} onChange={() => toggleSelect(row.vehicle_code, row)} /></td>
                  <td className="em-td" style={{ color:'#64748b', fontSize:12 }}>{row.vehicle_code}</td>
                  <td className="em-td" style={{ fontWeight:600 }}>{row.vehicle_name}</td>
                  <td className="em-td" style={{ fontSize:12 }}>{row.vehicle_registration_number}</td>
                  <td className="em-td" style={{ fontSize:12 }}>{row.team}</td>
                  <td className="em-td" style={{ fontSize:12 }}>{row.vehicle_model_id}</td>
                  <td className="em-td" style={{ fontSize:12 }}>{row.fleet_type}</td>
                  <td className="em-td" style={{ fontSize:12 }}>{row.fuel_type}</td>
                  <td className="em-td">
                    <span className={`em-badge ${(row.isActive===1||row.isActive===true)?'em-badge-green':'em-badge-red'}`}>
                      {(row.isActive===1||row.isActive===true)?'Active':'Inactive'}
                    </span>
                  </td>
                  <td className="em-td" style={{ fontSize:12 }}>{row.mileage}</td>
                  <td className="em-td">
                    <button className="em-btn em-btn-ghost" style={{ padding:'5px 10px', fontSize:11 }} onClick={() => openEdit(row)}>
                      <i className="fa fa-pencil" />
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <div style={{ padding:'10px 16px', background:'#f8fafc', borderTop:'1px solid #e8edf2', fontSize:12, color:'#94a3b8', fontWeight:600 }}>
        {selectedIds.length > 0 ? `${selectedIds.length} selected · ` : ''}{filtered.length} vehicle{filtered.length!==1?'s':''}
      </div>

      {drawerOpen && (
        <>
          <div className="em-overlay" onClick={closeDrawer} />
          <div className="em-drawer">
            <div className="em-drawer-header">
              <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between' }}>
                <div style={{ display:'flex', alignItems:'center', gap:12 }}>
                  <div style={{ width:36, height:36, borderRadius:11, background:'rgba(255,255,255,0.12)', display:'flex', alignItems:'center', justifyContent:'center' }}>
                    <i className="fa fa-truck" style={{ color:'#fff', fontSize:16 }} />
                  </div>
                  <div>
                    <p className="em-drawer-title">{isEdit ? 'Edit Vehicle' : 'Add New Vehicle'}</p>
                    <p className="em-drawer-sub">{isEdit ? `Code: ${form.vehicle_code}` : 'Fill in the vehicle details below'}</p>
                  </div>
                </div>
                <button onClick={closeDrawer} style={{ background:'rgba(255,255,255,0.1)', border:'none', borderRadius:10, width:30, height:30, cursor:'pointer', color:'#fff', fontSize:18, display:'flex', alignItems:'center', justifyContent:'center' }}>×</button>
              </div>
            </div>
            <div className="em-drawer-body">
              <div className="em-form-2col">
                <div className="em-form-row">
                  <label className="em-label">Vehicle Name<span className="em-req">*</span></label>
                  <input className="em-field" value={form.vehicle_name||''} placeholder="e.g. Toyota Hiace"
                    onChange={e => setForm(p => ({ ...p, vehicle_name: e.target.value }))} />
                </div>
                <div className="em-form-row">
                  <label className="em-label">Registration No.<span className="em-req">*</span></label>
                  <input className="em-field" value={form.vehicle_registration_number||''} placeholder="e.g. DXB-1234"
                    onChange={e => setForm(p => ({ ...p, vehicle_registration_number: e.target.value }))} />
                </div>
              </div>
              <div className="em-form-2col">
                <div className="em-form-row">
                  <label className="em-label">Team<span className="em-req">*</span></label>
                  <select className="em-field" value={form.team||''} onChange={e => setForm(p => ({ ...p, team: e.target.value }))}>
                    <option value="">— Select team —</option>
                    {teams.map(t => <option key={t.teamId} value={t.teamId}>{t.teamName}</option>)}
                  </select>
                </div>
                <div className="em-form-row">
                  <label className="em-label">Vehicle Model<span className="em-req">*</span></label>
                  <select className="em-field" value={form.vehicle_model_id||''} onChange={handleModelChange}>
                    <option value="">— Select model —</option>
                    {vehicleModels.map(m => <option key={m.vehicle_model_code} value={m.vehicle_model_code}>{m.vehicle_model_name}</option>)}
                  </select>
                </div>
              </div>
              <div className="em-form-2col">
                <div className="em-form-row">
                  <label className="em-label">Fleet Type <span className="em-auto-tag">auto</span></label>
                  <input className="em-field" value={form.fleet_type||''} placeholder="Auto-filled from model"
                    onChange={e => setForm(p => ({ ...p, fleet_type: e.target.value }))} />
                </div>
                <div className="em-form-row">
                  <label className="em-label">Fuel Type <span className="em-auto-tag">auto</span></label>
                  <input className="em-field" value={form.fuel_type||''} placeholder="Auto-filled from model"
                    onChange={e => setForm(p => ({ ...p, fuel_type: e.target.value }))} />
                </div>
              </div>
              <div className="em-form-2col">
                <div className="em-form-row">
                  <label className="em-label">Transporter ID</label>
                  <input className="em-field" type="number" value={form.transported_id||''} placeholder="0"
                    onChange={e => setForm(p => ({ ...p, transported_id: e.target.value }))} />
                </div>
                <div className="em-form-row">
                  <label className="em-label">Mileage (km)</label>
                  <input className="em-field" type="number" value={form.mileage||''} placeholder="0"
                    onChange={e => setForm(p => ({ ...p, mileage: e.target.value }))} />
                </div>
              </div>
              <div className="em-form-row" style={{ maxWidth:220 }}>
                <label className="em-label">Status<span className="em-req">*</span></label>
                <select className="em-field"
                  value={(form.isActive===1||form.isActive===true)?'1':'2'}
                  onChange={e => setForm(p => ({ ...p, isActive: e.target.value==='1' }))}>
                  <option value="1">Active</option>
                  <option value="2">Inactive</option>
                </select>
              </div>
              {msg    && <p className="em-msg-error">{msg}</p>}
              {errMsg && <p className="em-msg-error">{errMsg}</p>}
            </div>
            <div className="em-drawer-footer">
              <button className="em-dismiss-btn" onClick={closeDrawer}>Cancel</button>
              <button className="em-save-btn" onClick={handleSubmit}>
                <i className="fa fa-check" style={{ marginRight:6 }} />{isEdit?'Update Vehicle':'Save Vehicle'}
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
